import { useEffect, useState } from "react";
import "./ResponseDetailsNPS.css";
import { FormResponseExtended, Question } from "effno-core";
import { Response } from "effno-core";

type ResponseDetailsNPSProps = {
    question: Question | null;
    responses: FormResponseExtended[] | null;
}

export const ResponseDetailsNPS = ({question, responses} : ResponseDetailsNPSProps) => {

    let scores = 0;
    let scoreTotal = 0;

    const min = 0;
    const max = 10; 

    const scoreArray : string [] = [];
    for (let i = min; i <= max; i++) {
        scoreArray.push(i.toString());
    }

    const responsesArray = new Array(scoreArray.length).fill(0);
    const colorArray = ["red", "red", "red", "red", "red", "red", "red", "orange", "orange", "green", "green"];

    if (responses) {
        responses.forEach((formResponse: FormResponseExtended)  => {
            formResponse.responses.forEach((response: Response) => {
                if (response.questionId === question?.id) {
                    const responseValues = JSON.parse(response.responseValues);
                    const score = responseValues.score;

                    if (score) {
                        const index = scoreArray.indexOf(score.toString());

                        if (index !== -1) {
                            responsesArray[index] += 1;
                            scores++;
                            scoreTotal += score;
                        }
                    }

                }

            })
        });
    }

    const promoters = responsesArray[9] + responsesArray[10];
    const detractors = responsesArray[0] + responsesArray[1] + responsesArray[2] + responsesArray[3] + 
        responsesArray[4] + responsesArray[5] + responsesArray[6];

    const npsScore = scores > 0 ? 
        Math.floor(promoters / scores * 100) -
        Math.floor(detractors / scores * 100) : 0;

    console.log("[ResponseDetailsRating] scoreArray: ", scoreArray);
    console.log("[ResponseDetailsRating] responsesArray: ", responsesArray);
    console.log("[ResponseDetailsRating] promoters: ", promoters);
    console.log("[ResponseDetailsRating] detractors: ", detractors);

    return (
        <div className="response-details-nps">
            <div className="response-details-nps-header">
                <div className="response-details-generic-stat">
                    Scores: {scores}
                </div>
                <div className="response-details-generic-stat">
                    NPS: {npsScore.toFixed(0)}%
                </div>
            </div>

            <div className="response-details-nps-scores">
                {scoreArray.map((score, index) => {
                    const percentage = Math.floor((responsesArray[index] / scores) * 100);
                    return (
                        <div className="response-details-nps-entry">
                            <div 
                                className="response-details-nps-value"
                                style={{backgroundColor: colorArray[index]}}
                            >
                                {score}
                            </div>
                            <div className="response-details-nps-bar-container">
                                <div 
                                    className="response-details-nps-bar-value"
                                    style={{width: `${percentage}%`}}
                                >
                                    {}
                                </div>
                            </div>
                            <div className="response-details-nps-bar-responses">
                                {responsesArray[index]} responses
                            </div> 
                        </div>
                    )
                })}
             </div>

        </div>
    )
}